import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import style from './style.scss'; //NOSONAR

const LinkCustom = (props) => {
    const {to, target, style, className, onClick, children} = props;

    const LinkIsInternal = (to, target) => {
        return !((target === '_blank') || to && (to.indexOf('//') !== -1 || to.indexOf('wwww.') !== -1));
    }

    let isInternal = LinkIsInternal(to, target);
    let link = '';
    let click = onClick ? onClick : ()=>{};
    if(isInternal){
        link = (
            <Link {...props} onClick={()=> click()}>
                {children}
            </Link>
        )
    }else{
        link = (
            <a className={className} onClick={()=> click()} style={style} href={to} target={target} rel={(target === '_blank') ? 'noopener noreferrer' : ''}>
                {children}
            </a>
        )
    }

    return link;
}

LinkCustom.propTypes = {
    className: PropTypes.string,
    target: PropTypes.string,
    to: PropTypes.string,
    style: PropTypes.object,
    onClick:  PropTypes.func,
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.string,
        PropTypes.object,
        PropTypes.node
    ])
}

export default LinkCustom;
